import z from "zod";

import { ErrorClassification } from "../../../sentry/classification";
import type { ErrorDetails } from "../domain";

const takeRateErrorTypeValues = ["REFRESH_TOO_RECENT", "NOT_IMPLEMENTED"] as const;
const takeRateErrorTypeSchema = z.enum(takeRateErrorTypeValues);
const TakeRateErrorType = takeRateErrorTypeSchema.enum;
type TakeRateErrorType = z.infer<typeof takeRateErrorTypeSchema>;

export type TakeRateErrors =
  | {
      errorType: typeof TakeRateErrorType.REFRESH_TOO_RECENT;
      data: { lastGeneratedAt: Date; triggeredBy: string };
    }
  | { errorType: typeof TakeRateErrorType.NOT_IMPLEMENTED; data: { message: string } };

export const takeRateErrorDetails: Record<TakeRateErrorType, ErrorDetails> = {
  REFRESH_TOO_RECENT: {
    classification: ErrorClassification.VALIDATION_ERROR,
    sentryDescription: "Portfolio snapshot was generated too recently — concurrent refresh rejected",
  },
  NOT_IMPLEMENTED: {
    classification: ErrorClassification.UNEXPECTED_ERROR,
    sentryDescription: "Take-rate feature not yet implemented",
  },
};
